import React, { useContext } from 'react';
import { BopisContext } from '@core-ui/bopis';
import LeftFacetedGridMediator, {
  RawLeftFacetedGridMediator,
} from './mediator';
import { propTypes } from './types';
import useFlexFacets from '../../hooks/features/useFlexFacets/useFlexFacets';
import useBRRedesign from '../../hooks/features/useBRRedesign';
import useSwitchContract from '../../hooks/features/useSwitchContract';
import useBRRedesignOpacity from '../../hooks/features/useBRRedesignOpacity/useBRRedesignOpacity';
import RailContainer from '../rail-container';
import ProductGridRegion from '../product-grid-region';
import useRatingsFacet from '../../hooks/features/useRatingsFacet/useRatingsFacet';
import useDashboard from '../../hooks/features/useDashboard/useDashboard';
import useDynamicStyleFacetName from '../../hooks/features/useDynamicStyleFacetName';
import useOutOfStockFilter from '../../hooks/features/useOutOfStockFilter';
import { useRelatedCategories } from '../related-categories/context';

const LeftFacetedGrid = (props) => {
  const { abbrBrand, abSeg, isModelToggleEnabled, isMixedGridEnabled } = props;
  const { onFacetChange } = useRelatedCategories();
  const isFlexFacetEnabled = useFlexFacets();
  const isBRRedesignEnabled = useBRRedesign();
  const isBRRedesignOpacityEnabled = useBRRedesignOpacity();
  const isRatingsFacetEnabled = useRatingsFacet();
  const isDashboardEnabled = useDashboard();
  const isDynamicStyleFacetNameEnabled = useDynamicStyleFacetName();
  const bopisData = useContext(BopisContext);
  const isSwitchContractEnabled = useSwitchContract();
  const isOutOfStockFilterEnabled = useOutOfStockFilter();

  return (
    <LeftFacetedGridMediator
      {...props}
      onFacetChange={onFacetChange}
      bopisData={bopisData}
      isFlexFacetEnabled={isFlexFacetEnabled}
      isRatingsFacetEnabled={isRatingsFacetEnabled}
      isDynamicStyleFacetNameEnabled={isDynamicStyleFacetNameEnabled}
      isBRRedesignEnabled={isBRRedesignEnabled}
      isSwitchContractEnabled={isSwitchContractEnabled}
    >
      <RailContainer
        abbrBrand={abbrBrand}
        abbrNameForTealium={props.abbrNameForTealium}
        businessUnitId={props.businessUnitId}
        categoryName={props.categoryName}
        contentData={props.contentData}
        datalayer={props.datalayer}
        leftNav={props.leftNav}
        pageType={props.pageType}
        mediator={RawLeftFacetedGridMediator}
        selectedNodes={props.selectedNodes}
        webHierarchy={props.webHierarchy}
        isModelToggleEnabled={isModelToggleEnabled}
        isMixedGridEnabled={isMixedGridEnabled}
        isDashboardEnabled={isDashboardEnabled}
        isBRRedesignEnabled={isBRRedesignEnabled}
        isBRRedesignOpacityEnabled={isBRRedesignOpacityEnabled}
        cid={props.cid}
        isSwitchContractEnabled={isSwitchContractEnabled}
        isOutOfStockFilterEnabled={isOutOfStockFilterEnabled}
      />
      <ProductGridRegion
        abSeg={abSeg}
        brand={abbrBrand}
        cid={props.cid}
        criticalCss={props.criticalCss}
        highPriorityEvents={props.highPriorityEvents}
        mediator={RawLeftFacetedGridMediator}
        locale={props.locale}
        isModelToggleEnabled={isModelToggleEnabled}
        isMixedGridEnabled={isMixedGridEnabled}
        productGridSource="pds"
        {...props}
      />
    </LeftFacetedGridMediator>
  );
};

LeftFacetedGrid.propTypes = propTypes;

export default LeftFacetedGrid;
